import { createClient } from '@/shared/api';
import UPDATE_BEATS_AND_EVENTS_MUTATION from '@/entities/beat/api/mutations/updateBeatsAndEvents';
import type {
  UpdateBeatsAndEventsMutation,
  UpdateBeatsAndEventsMutationVariables,
} from '@/shared/api/generated/graphql';

export type UpdateBeatsAndEventsResult = {
  isSuccess: boolean;
  message: string;
  messageId: string;
  command: string;
};

// TODO(ts): typed as the UpdateBeatsAndEventsInput GraphQL input once its server-side shape is documented
/**
 * Persists edited beats together with the events derived from them. Runs the updateBeatsAndEvents mutation and throws with the server message when isSuccess is false.
 *
 * @param input - Mutation input carrying the beat and event edits.
 * @returns A promise resolving to the updateBeatsAndEvents result.
 */
const handleUpdateBeatsAndEvents = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    UpdateBeatsAndEventsMutation,
    UpdateBeatsAndEventsMutationVariables
  >({
    mutation: UPDATE_BEATS_AND_EVENTS_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { updateBeatsAndEvents } = data;
  if (!updateBeatsAndEvents.isSuccess) {
    throw new Error(updateBeatsAndEvents.message);
  }
  return updateBeatsAndEvents;
};

export default handleUpdateBeatsAndEvents;
